import React from "react";
import { Accordion, Button, Card, Container, Row, Col } from "react-bootstrap";

const Progressive = () => {
  return (
    <section className="keyzi_content--wrapper">
      <Container>
        <div className="keyzi_content--inner">
          <Row>
            <Col md={12}>
              <Card className="p-4">
                <Row>
                  <Col md={6}>
                    <h4>Learning Is Progressive</h4>
                    <p>
                      Your instructor will work with you in either a quiet
                      location or in busier traffic conditions, depending on
                      your confidence and skill level.
                    </p>
                    <ul>
                      <li>
                        All Keyzi driving instructors have modern dual-controlled
                        cars.
                      </li>
                      <li>
                        Instructors advise how many lessons they think you'll need after assessing your first lesson.
                      </li>
                      <li>Driving lessons typically go for 1 or 2 hours.</li>
                      <li>
                        Your lesson pick-up and drop-off points are your choice:
                        home, school, shops, or a friend's place.
                      </li>
                    </ul>
                    <Button href="#find-instructor" variant="primary">
                      Book Lessons Now
                    </Button>
                  </Col>
                  <Col md={6}>
                    <h4>Frequently Asked Questions</h4>
                    <Accordion defaultActiveKey="0">
                      <Accordion.Item eventKey="0">
                        <Accordion.Header>
                          How many driving lessons do I need?
                        </Accordion.Header>
                        <Accordion.Body>
                          The number of lessons varies for each individual.
                          Your instructor will assess your skills during the
                          first lesson and provide a recommendation. On
                          average, learners take between 20-40 hours of lessons
                          before being ready for their test.
                        </Accordion.Body>
                      </Accordion.Item>

                      <Accordion.Item eventKey="1">
                        <Accordion.Header>Can I practice between lessons?</Accordion.Header>
                        <Accordion.Body>
                          Yes, practicing between lessons is encouraged. You
                          can practice with a fully licensed driver, following
                          the rules set by your local transport authority.
                          This additional practice can help reinforce what
                          you've learned and build confidence.
                        </Accordion.Body>
                      </Accordion.Item>

                      <Accordion.Item eventKey="2">
                        <Accordion.Header>What happens during the first driving lesson?</Accordion.Header>
                        <Accordion.Body>
                          Your first lesson typically involves an introduction
                          to the car's controls, basic maneuvers in a quiet
                          area, and an assessment of your current skill level.
                          The instructor will use this information to plan
                          your future lessons.
                        </Accordion.Body>
                      </Accordion.Item>

                      <Accordion.Item eventKey="3">
                        <Accordion.Header>How do I prepare for my driving test?</Accordion.Header>
                        <Accordion.Body>
                          Your instructor will guide you through test
                          preparation, including practicing common test
                          routes, perfecting maneuvers, and reviewing road
                          rules. They'll also help you understand the test
                          structure and scoring criteria.
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
        </div>
      </Container>
    </section>
  );
};

export default Progressive;
